<template>
  <div id="chatBox" :class="['gptChatBox', isDark ? 'dark' : '']" :style="{height: heroHeight}">
    <div class="menusBox">
      <!-- <button @click="ceshi">ceshi</button> -->
      <Menus></Menus>
    </div>
    <div class="mainBox">
      <div class="functions">
        <Middle @goChat="goMiddle"></Middle>
      </div>
      <transition name="gptChat">
        <div class="jwChat" v-show="isShowChat">
          <!-- <div class="jwChat" v-if="isShowChat"> -->
          <NewChat @goMiddle="goMiddle" ref="chatRef"></NewChat>
        </div>
      </transition>
    </div>
    <!-- 引导页 -->
    <transition name="fade">
      <div class="hintBox" v-if="isShowHint">
        <div class="hint">
          <div class="imgBox">
            <img src="@/assets/chatImg/bg-1.png" alt="">
          </div>
          <h4>你需要选择对话角色进行操作吗？</h4>
          <div class="btnBox">
            <el-button type="text" class="linkBtn" @click="needAction">需要</el-button>
            <el-button type="text" class="linkBtn" @click="notAction">跳过</el-button>
          </div>
        </div>
      </div>
    </transition>
    <!-- 设置密码 -->
    <SetPwd :dialogVisible="showSetPwd" @close="closeSetPwd" />
  </div>
</template>

<script>
// import jwChat from './chat.vue';
import Menus from './components/menus';
import SetPwd from './components/setPwd';
import Middle from './middle';
import Chats from './middle/chats';
import ChatHistory from './middle/chatHistory';
import NewChat from './newChat';
import api from '@/api';
// import { enumMessageCode, enumCallType } from '@/store/enum';
import config from '@/config';
// import * as signalR from '@microsoft/signalr';
import { Marked } from 'marked';
import { markedHighlight } from 'marked-highlight';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';
import utils from '@/utils/utils';
import { mapState, mapMutations } from 'vuex';

const marked = new Marked(
  markedHighlight({
    langPrefix: 'hljs language-',
    highlight(code, lang, info) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext'
      return hljs.highlight(code, { language }).value
    },
  })
)

export default {
  name: 'chat',
  components: { Menus, Middle, Chats, ChatHistory, NewChat, SetPwd },
  props: {},
  data() {
    return {
      isShowChat: false,
      session: '',
      // sessionKey: 'sessionKey',
      taleList: [],
      //用户认证
      isAuth: false,
      loading: false, // 发送按钮-暂未绑定
      autoLogin_loading: false, // 未绑定
      received: true,
      send_loading: false,
      openAIAccount: {},
      // 接口
      GetWXAuthUrl: api.GetWXAuthUrl,
      getUserInfo: api.getUserInfo,
      wsServerUrl: config.BASE_URL_WS,
      apiServerUrl: config.BASE_URL,
      // callType: enumCallType.WebSocket,
      GetChatHistory: api.GetChatHistory,
      GetOpenAIAccount: api.GetOpenAIAccount,
      SyncChatHistory: api.SyncChatHistory,
      // 连接
      reconnectMS: 2000,
      connecting: false,
      // connection: null,
      GetAiassistantList: api.GetAiassistantList,
      // 设置密码模态框开关
      showSetPwd: false,
      heroHeight: '100vh',
    }
  },
  computed: {
    ...mapState('userAbout', ['user', 'sessionKey']),
    ...mapState('comAbout', ['isDark', 'isShowHint']),
  },
  watch: {
  },
  created() { },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化windowHeight
    //读取登录数据
    this.fromLogin();
    // PC端默认捷捷AI
    if (!config.isMobile) {
      this.getChatList();
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...mapMutations('userAbout', ['setUser', 'changeAutoLogin', 'changeAiAssistantId', 'changeAiAssistant']),
    ...mapMutations('comAbout', ['changeIsShowHint', 'changeComponentName']),
    // ceshi(){
    //   console.log('ceshi');
    //   this.showSetPwd = true;
    // },
    // 关闭设置密码模态框
    closeSetPwd() {
      // console.log('close');
      this.showSetPwd = false;
    },
    // 判断用户是否第一次登录
    isUserFirst() {
      const userList = JSON.parse(localStorage.getItem('userList')) || [];
      // console.log(this.user.phone, '用户', userList);
      const isFirst = userList.includes(this.user.phone);
      // 移动端展示引导页，非微信浏览器
      if (!isFirst && config.isMobile && !utils.isWechat()) {
        // if (config.isMobile) {
        this.changeIsShowHint(true);
        const newUserList = userList.concat(this.user.phone);
        localStorage.setItem('userList', JSON.stringify(newUserList));
      }
    },
    // 获取AI助手
    getChatList() {
      this.GetAiassistantList().then((res) => {
        this.changeAiAssistantId(res.data[0].id);
        const chatList = res.data?.map(item => {
          return {
            ...item,
            avatar: item.avatarFileUrl,
            textTitle: item.name,
            textContent: item.describe,
          }
        })
        this.changeAiAssistant(chatList[0]);
        this.isShowChat = true;
      })
    },
    // 需要引导
    needAction() {
      // console.log('需要');
      this.changeIsShowHint(false);
      this.changeComponentName('ChatHistory');
      this.isShowChat = false;
    },
    // 不需要引导
    notAction() {
      // console.log('不需要', '跳转跟捷捷AI聊天');
      this.changeIsShowHint(false);
      // this.isShowChat = true;
      this.getChatList();
    },
    // 监听页面宽度--网页宽度变化时收起/展示聊天框
    handleResize() {
      // console.log('高度', window.innerHeight);
      // this.windowWidth = window.innerWidth;
      if (!config.isMobile) {
        if (window.innerWidth > 990) {
          this.isShowChat = true;
        } else {
          this.isShowChat = false;
        }
      }
      // 调整页面高度
      if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {//判断设备类型
        this.heroHeight = `${window.innerHeight}px`;
      } else {
        this.heroHeight = '100vh';
      }
    },
    // 收起聊天页面
    goMiddle() {
      // 宽度过小时才收起
      if (window.innerWidth <= 990) {
        this.isShowChat = !this.isShowChat;
      }
    },
    //来自登录页面
    fromLogin() {
      let res = localStorage.getItem('temp_login')
      if (res) {
        res = JSON.parse(res)
        this.setUser(res.data);
        // this.onLoginOk(res) //1
        this.$refs.chatRef.loginOkThen();
        localStorage.removeItem('temp_login')
        // 判断用户是否第一次登录
        this.isUserFirst();
      } else {
        console.log('自动登录');
        //自动登录
        this.autoLogin()
      }
    },
    //自动登录
    autoLogin() {
      this.autoLogin_loading = true
      // debugger;
      this.getUserInfo({ autoLogin: true })
        .then((res) => {
          // console.log(res.data, '登录');
          // 更新仓库user
          this.setUser(res.data);
          this.changeAutoLogin(true);
          if (res.data != null) {
            this.$message({
              message: `已自动登录：${res.data.account}`,
              type: 'success',
            })
            res.autoLogin = true
            // this.onLoginOk(res)
            this.$refs.chatRef.loginOkThen();
            // 无账号密码
            if (!res.data.account) {
              this.showSetPwd = true;
            } else {
              // 判断用户是否第一次登录
              this.isUserFirst();
            }
            // 判断用户是否第一次登录
            // this.isUserFirst();
          } else {
            //获取失败跳转登录
            this.$router.push('/login')
          }
          this.autoLogin_loading = false
        })
        .catch((e) => {
          //获取失败跳转登录
          this.$router.push('/login')
          this.autoLogin_loading = false
        })
    },
  }
}
</script>

<style scoped lang="less">
.gptChatBox {
  background: #f1f7fe;
  // height: 100vh;
  display: flex;

  .mainBox {
    width: calc(100vw - 100px);
    display: flex;

    .functions {
      height: 100vh;
      width: 470px;
    }

    .jwChat {
      height: 100%;
      margin: 0 auto;
      padding: 0 30px;
      flex: 1;
      background: #fff;
    }

    @media screen and (max-width: 1400px) {
      .functions {
        width: 400px;
      }

      .jwChat {
        width: calc(100vw - 100px - 400px);
      }
    }
  }

  // 引导页收起动画
  .fade-enter-active,
  .fade-leave-active {
    .hint {
      transition: all .3s ease-out;
    }
  }

  .fade-enter-to,
  .fade-leave

  /* .fade-leave-active for <=2.1.8 */
    {
    .hint {
      transform: none;
      opacity: 1;
    }
  }

  .fade-enter,
  .fade-leave-to {
    .hint {
      transform: translate(0, -50px);
      opacity: 0;
    }
  }

  .hintBox {
    width: 100vw;
    height: 100vh;
    transition: opacity .15s linear;
    overflow-x: hidden;
    overflow-y: auto;
    position: absolute;
    top: 0;
    left: 0;
    backdrop-filter: blur(1.5px);
    background: rgba(0, 0, 0, .6);
    display: flex;
    justify-content: center;
    align-items: center;

    .hint {
      max-width: 800px;
      border-radius: 10px;
      background-color: #f8f7fb;
      max-height: 577px;
      overflow: hidden;
      padding-bottom: 55px;

      // transform: none;
      // transform: translate(0, -50px);
      // transition: transform .3s ease-out;
      .imgBox {
        width: 100%;
      }

      h4 {
        font-size: 22px;
        font-weight: 500;
        color: #222;
        margin: 15px auto 24px;
        text-align: center;
      }

      .btnBox {
        display: flex;
        justify-content: center;
        align-items: center;

        .linkBtn {
          color: #007bff;
          font-size: 16px;
          padding: 6px 12px;
          margin: 0;

          &:hover {
            color: #0056b3;
            text-decoration: underline;
          }
        }
      }
    }

    // .hideHint {
    //   transform: none;
    // }
  }
}

.dark {
  background-color: #1a2236;
  color: #ddd;

  .mainBox {
    .functions {
      border-right: 2px solid #293145;
    }

    .jwChat {
      background: #1a2236;
    }
  }

  /deep/.el-dialog {
    background-color: #293145;
  }

  /deep/.el-dialog__title {
    color: #fff;
  }

  /deep/.el-dialog__body {
    color: #aaa;
  }

  // /deep/.el-dialog__body {
  //   color: #aaa;
  // }
}

@media screen and (max-width: 990px) {
  #chatBox {
    flex-direction: column-reverse;
    // height: 100vh;

    .menusBox {
      height: 63px;
    }

    .mainBox {
      height: calc(100vh - 63px);
      width: 100vw;
      overflow-x: hidden;
      overflow-y: auto;

      .functions {
        width: 100vw;
        height: 100%;
      }

      .jwChat {
        width: 100vw;
        position: absolute;
        top: 0;
        left: 0;
        padding: 0;

      }
    }

    // 聊天页收起动画
    .gptChat-enter-active,
    .gptChat-leave-active {
      transition: all .3s ease-out;
    }

    .gptChat-enter-to,
    .gptChat-leave

    /* .fade-leave-active for <=2.1.8 */
      {
      transform: translateX(0);
    }

    .gptChat-enter,
    .gptChat-leave-to {
      transform: translateX(100%);
    }
  }
}

// /deep/.el-message-box {
//   background-color: #1a2236;
// }</style>
